/** Currency display helpers shared across the configurator. */

// The Mexican peso uses the `$` glyph (same as USD) — matching the operator-facing site, which
// writes amounts as `$100 MXN` (symbol + a trailing ISO code to disambiguate), NOT `MX$100`.
const SYMBOLS: Record<string, string> = {
  USD: '$',
  MXN: '$',
  EUR: '€',
  GBP: '£',
  RON: 'lei ',
  BRL: 'R$',
};

export const currencySymbol = (code: string): string => SYMBOLS[code] ?? `${code} `;

/** Format a bare amount (no symbol/code), e.g. 1102.67 → "1,102.67". */
export function formatAmount(n: number): string {
  return n.toLocaleString('en-US', { maximumFractionDigits: 2 });
}

/**
 * Format an amount with its ISO currency code suffix but NO symbol, e.g. "120 USD" / "0 MXN".
 * Used by the price displays that render the currency SYMBOL as a separately-styled element and
 * only need the amount+code in the value slot (so "$" + "120 USD" reads "$120 USD"). USD and MXN
 * both use the `$` glyph, so the trailing code is what disambiguates them.
 */
export function formatAmountWithCode(amount: number, code: string): string {
  return `${formatAmount(amount)} ${code}`;
}

/** Format an amount with its currency symbol AND ISO code, e.g. "$120 USD", "$0 MXN". */
export function formatMoney(amount: number, code: string): string {
  return `${currencySymbol(code)}${formatAmountWithCode(amount, code)}`;
}
